import { Logo } from './Logo';
import { OptionsWrapper } from './OptionsWrapper';
import './top-bar.css';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const TopBar = ({ options }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  // Lock body scroll while the menu is open
  useEffect(() => {
    if (isMenuOpen) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [isMenuOpen]);

  return (
    <>
      <nav className="snn-top-menu-wrapper">
        <Logo />
        <OptionsWrapper options={options} isMenuOpen={isMenuOpen} closeMenu={closeMenu} />
        <button
          type="button"
          className={`snn-menu-button ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          <span className="snn-menu-button-bar"></span>
          <span className="snn-menu-button-bar"></span>
          <span className="snn-menu-button-bar"></span>
        </button>
      </nav>
      <div
        className={`snn-menu-backdrop ${isMenuOpen ? 'open' : ''}`}
        onClick={closeMenu}
        aria-hidden="true"
      />
    </>
  );
};

TopBar.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    }),
  ).isRequired,
};
